<template>
  <div class="bookmark-tags d-flex align-center">
    <v-chip
      v-for="tag in capped" :key="tag.id"
      color="neutral30" size="small"
      variant="flat"
      class="tag-chip"
      @click.prevent.stop="emit('tag-selected', tag)"
    >
    <span class="text-truncate">{{ tag.name }}</span>
    </v-chip>

    <span
      v-if="tags.length > max"
      class="font-weight-semibold text-caption"
    >
      +{{ tags.length - max }}
    </span>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
  tags: {
    type: Array,
    required: true,
  },
  max: {
    type: Number,
    default: 3,
  },
})

const emit = defineEmits(['tag-selected'])

const capped = computed(() => {
  return props.tags.slice(0, props.max)
})
</script>

<style lang="scss" scoped>
.bookmark-tags {
  gap: 4px;
}

// Style tags to match Vue 2 with proper dark mode support
.tag-chip {
  // Match Vue 2 chip dimensions using padding
  &.v-chip--size-small {
    height: auto !important;
    line-height: 20px !important;
    font-size: 0.75rem !important;
    // 2px vertical padding + 20px line-height = 24px total height
    // 12px horizontal padding for more generous spacing like Vue 2
    padding: 2px 12px !important;
    min-height: 24px !important; // Ensure minimum height
  }
}
</style>
